module.exports = __webpack_public_path__ + "static/media/error.c3e30ca5.svg";